/* businesses */
export const LIST_SUPPORT_MATERIAL_TYPES = "LIST_SUPPORT_MATERIAL_TYPES"
export const LIST_SUPPORT_MATERIAL_TYPES_SUCCESS =
  "LIST_SUPPORT_MATERIAL_TYPES_SUCCESS"
export const LIST_SUPPORT_MATERIAL_TYPES_CLEAN =
  "LIST_SUPPORT_MATERIAL_TYPES_CLEAN"
export const LIST_SUPPORT_MATERIAL_TYPES_ERROR =
  "LIST_SUPPORT_MATERIAL_TYPES_ERROR"
